export function createStatics(stateKey = "Bihar", tenthResult = true) {
  let statics = {
    title: "",
    description: "",
    keywords: "",
    canonical: "/education/board-results/",
    imgSrc: "",
    imgSrcMobile: "",
    content:
      "Board Exam Results: CBSE, CISCE समेत अधिकतर स्टेट बोर्ड (State Board Exams) मार्च-अप्रैल तक बोर्ड परीक्षाएं आयोजित करा लेते हैं. परीक्षाएं खत्म होते ही छात्रों को अपने रिजल्ट का इंतजार होता है. छात्रों की सहूलियत के लिए newstak.in पर यूपी बोर्ड (UP Board), महाराष्‍ट्र बोर्ड (Maharashtra Board), राजस्‍थान बोर्ड (Rajasthan Board) समेत कई स्टेट बोर्ड के नतीजे उपलब्ध कराए जाते हैं. यहां स्टूडेंट्स आसानी से अपने स्कोर चेक कर सकते हैं. स्‍टूडेंट्स इस पेज पर आकर न सिर्फ अपने स्‍टेट बोर्ड रिजल्‍ट देख सकते हैं बल्कि रोल नंबर की मदद से अपनी मार्कशीट भी डाउनलोड कर सकते हैं. रिजल्‍ट की घोषणा के साथ ही डाउनलोड लिंक सबसे पहले इसी पेज पर लाइव हो जाता है.",
    segment: "",
    stateText: "",
    breadCrumbs: [
      {
        id: "1",
        title: "एजुकेशन",
        canonical_url: "/education",
        amp_url: "",
      },
      {
        id: "2",
        title: "बोर्ड रिजल्ट",
        canonical_url: "/education/board-results",
        amp_url: "",
      },
    ],
    h1: "बोर्ड 10th परीक्षा परिणाम",
    info: "",
  };

  if (tenthResult) {
    statics.imgSrc =
      "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/board_desktop_banner_10.png";
    statics.imgSrcMobile =
      "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/board_cat_banner_10.png";

    if (stateKey == "Bihar") {
      statics.title =
        "Check Online Bihar Board 10th Result 2025, BSEB मैट्रिक रिजल्ट - NewsTak";
      statics.description =
        "Check Online Bihar Board 10th Result 2025 (बिहार बोर्ड मैट्रिक रिजल्ट). Get BSEB 10वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत की पूरी जानकारी यहाँ।";
      statics.keywords =
        "Bihar Board 10th Result 2025, BSEB मैट्रिक रिजल्ट, Bihar Board Matric Result 2025, BSEB Result 2025, 10वीं रिजल्ट बिहार बोर्ड";
      statics.canonical =
        "/education/board-results/bseb-bihar-board-10th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "बिहार बोर्ड 10th परीक्षा परिणाम",
        canonical_url: "/education/board-results/bseb-bihar-board-10th-result",
        amp_url: "",
      });
      statics.h1 =
        "बिहार बोर्ड 10th परीक्षा परिणाम 2025 (Bihar Board Class 10th Result 2025)";
      statics.stateText = "बिहार";
      statics.info =
        "बिहार बोर्ड 10वीं हाईस्कूल रिजल्‍ट 2025 (Bihar Board 10th High School Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
    if (stateKey == "up") {
      statics.title =
        "Check Online UP Board 10th Result 2025: यूपी बोर्ड हाई स्कूल रिजल्ट - NewsTak";
      statics.description =
        "Check Online UP Board Class 10th Result 2025 (यूपी बोर्ड हाई स्कूल रिजल्ट): जानें उत्तर प्रदेश बोर्ड 10वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत से जुड़ी पूरी जानकारी यहाँ।";
      statics.keywords =
        "UP Board 10th Result 2025, UPMSP High School Result, यूपी बोर्ड 10वीं रिजल्ट, UP Board Result 2025, UP Board High School Marksheet, UP 10th Result Name Wise, up board class 12th result";
      statics.canonical =
        "/education/board-results/uttar-pradesh-board-10th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "यूपी बोर्ड 10th परीक्षा परिणाम",
        canonical_url:
          "/education/board-results/uttar-pradesh-board-10th-result",
        amp_url: "",
      });
      statics.h1 =
        "यूपी बोर्ड 10th परीक्षा परिणाम 2025 (UP Board Class 10th Result 2025)";
      statics.stateText = "यूपी";
      statics.content = `<p>यूपी बोर्ड (UPMSP) की 10वीं परीक्षा दे चुके लाखों स्टूडेंट्स फटाफट और सटीक नतीजे जानना चाहते हैं. वे एक भरोसेमंद प्लेटफॉर्म की तलाश में हैं. ऐसे लाखों छात्र-छात्राओं के लिए <strong>newstak.in</strong> एक भरोसे वाली वेबसाइट है. यहां सबसे तेज और सबसे सटीक नतीजे स्टूडेंट्स को मिलेंगे. UP Board 10th Result 2025 के लिए इस बार News Tak सबसे मुफीद प्लेटफॉर्म है.</p>

      <br/><p><strong>UP बोर्ड हाईस्कूल का रिजल्ट कब और कहां उपलब्ध होगा?</strong><br />
      यूपी बोर्ड 10वीं की परीक्षा खत्म हो चुकी है. सभी छात्र-छात्राओं के जेहन में एक ही सवाल है कि कब आएगा रिजल्ट? <strong>newstak.in</strong> यूपी बोर्ड के नतीजों से जुड़ी हर सटीक जानकारी और अपडेट स्टूडें‌ट्स को देता रहा है. यहीं छात्र-छात्राएं बेहद सटीक और सरल अंदाज में रिजल्ट भी देख पाएंगे. परिणाम घोषित होते ही वेबसाइट पर UP Board 10th result 2025 का एक टैब दिखेगा. इसे क्लिक करके स्टूडेंट्स नतीजे जान सकेंगे.</p>

      <br/><p><strong>इस बार डिजिलॉकर पर भी देख सकेंगे रिजल्ट</strong><br />
      पहली बार ऐसा होने जा रहा है कि डिजिलॉकर (DigiLocker) पर भी स्टूडेंट्स की मार्कशीट उपलब्ध होगी. <strong>newstak.in</strong> के बोर्ड रिजल्ट वाले पेज से ये जानकारी आपको मिलेगी कि डिजिलॉकर से 10th की मार्कशीट को कैसे डाऊलोड और प्रिंट किया जाए.</p>

      <br/><p><strong>UP Board 10th Result 2025 : नतीजे ऐसे जानें</strong></p>
      <ul className="list-disc list-inside">
        <li>सबसे पहले <strong><a target="_blank" href="https://upmsp.edu.in">upmsp.edu.in</a></strong> या <strong>newstak.in</strong> पर जाएं.</li>
        <li>'UP Board 10th Result 2025' वाले टैब पर क्लिक करें.</li>
        <li>बोर्ड वाले एडमिट कार्ड पर दिया गया रोल नंबर और मां का नाम दर्ज करें.</li>
        <li>‘View Result’ पर क्लिक करते ही नतीजा स्क्रीन पर दिखेगा.</li>
        <li>स्टूडेंट्स डिजिटल मार्कशीट डाउनलोड कर सकते हैं और प्रिंटआउट भी ले सकते हैं.</li>
      </ul>

      <br/><p>इसके साथ ही 10वीं के रिजल्ट से जुड़े कई सवालों के जवाब और गाइडेंस भी यहीं मिलेंगी. जुड़े रहें News Tak से.</p>`
      statics.segment = "UP-10-board-result";
      statics.info =
        "UP बोर्ड 10वीं हाईस्कूल रिजल्‍ट 2025 (UP Board 10th High School Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
    if (stateKey == "mp") {
      statics.title =
        "Check Online MP Board 10th Result 2025: MPBSE एमपी बोर्ड 10th रिजल्ट - NewsTak";
      statics.description =
        "Check Online MP Board Class 10th Result 2025 (एमपी बोर्ड हाई स्कूल रिजल्ट): जानें MPBSE Board Class 10वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत की पूरी जानकारी यहाँ।";
      statics.keywords =
        "MP Board 10th Result 2025, MPBSE High School Result, एमपी बोर्ड 10वीं रिजल्ट, MP Board Result 2025, MPBSE 10th Marksheet, MP Board Topper List 2025";
      statics.canonical =
        "/education/board-results/madhya-pradesh-board-10th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "MP बोर्ड 10th परीक्षा परिणाम",
        canonical_url:
          "/education/board-results/madhya-pradesh-board-10th-result",
        amp_url: "",
      });
      statics.h1 =
        "एमपी बोर्ड 10th परीक्षा परिणाम 2025 (MP Board Class 10th Result 2025)";
      statics.segment = "MP-10-board-result";
      statics.stateText = "एमपी";
      statics.info =
        "MP बोर्ड 10वीं हाईस्कूल रिजल्‍ट 2025 (MP Board 10th High School Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
      statics.content = "मध्य प्रदेश बोर्ड (MPBSE) 10वीं परीक्षा 2025 के नतीजे जल्द घोषित किए जाएंगे. छात्र अपना रिजल्ट mpresults.nic.in, mpbse.nic.in और mpbse.mponline.gov.in पर जाकर रोल नंबर और एप्लीकेशन नंबर डालकर चेक कर सकते हैं. यदि कोई छात्र अपने रिजल्ट से असंतुष्ट होता है, तो वह स्क्रूटनी (पुनर्मूल्यांकन) के लिए आवेदन कर सकता है. वहीं, 33% से कम अंक पाने वाले छात्र कंपार्टमेंट परीक्षा देकर अपनी परफॉर्मेंस सुधार सकते हैं. रिजल्ट घोषित होते ही छात्र SMS अलर्ट के जरिए भी अपनी मार्कशीट देख सकते हैं.  MP Board 10वीं में पास होने के लिए छात्रों को प्रत्येक विषय में कम से कम 33% अंक लाने होंगे. यदि कोई छात्र एक या दो विषयों में फेल हो जाता है, तो उसे कंपार्टमेंट परीक्षा देने का मौका मिलेगा. वहीं, यदि कोई छात्र अपने रिजल्ट से असंतुष्ट होता है, तो वह स्क्रूटनी (पुनर्मूल्यांकन) के लिए आवेदन कर सकता है."
    }
    if (stateKey == "jh") {
      statics.title =
        "Check Online Jharkhand Board 10th Result 2025: झारखंड बोर्ड मैट्रिक रिजल्ट - NewsTak";
      statics.description =
        "Check Online Jharkhand Board Calss 10th Result 2025 (झारखंड बोर्ड मैट्रिक रिजल्ट): जानें JAC Board 10वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत से जुड़ी पूरी जानकारी यहाँ।";
      statics.keywords =
        "Jharkhand Board 10th Result 2025, JAC 10th Result, झारखंड बोर्ड 10वीं रिजल्ट, JAC Result 2025, Jharkhand Matric Marksheet, JAC Topper List 2025, JAC calss 10th result";
      statics.canonical =
        "/education/board-results/jharkhand-board-10th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "Jharkhand बोर्ड 10th परीक्षा परिणाम",
        canonical_url: "/education/board-results/jharkhand-board-10th-result",
        amp_url: "",
      });
      statics.h1 =
        "झारखंड बोर्ड 10th परीक्षा परिणाम 2025 (Jharkhand Board Class 10th Result 2025)";
      statics.stateText = "झारखंड";
      statics.segment = "jharkhand-10-board-result";
      statics.content = `<p>झारखंड एकेडमिक काउंसिल (JAC) द्वारा झारखंड बोर्ड 10वीं की पारीक्षा 11 फरवरी से 4 मार्च, 2025 तक आयोजित की गई थी। एग्जाम खत्म होने के बाद से स्टूडेंट्स को रिजल्ट का बेशब्री से इंतजार है। इसी बीच रिजल्ट को लेकर ताजा अपडेट आ गया है। 10वीं के परिणाम 27 मई दिन मंगलवार को जारी किए जाएंगे।</p>

      <p>इस साल 10वीं के एग्जाम में 4.33 लाख स्टूडेंट्स शामिल हुए थे। छात्र-छात्राएं 10वीं के नतीजे फटाफट 
      <strong><a href="https://www.newstak.in" target="_blank">www.newstak.in</a></strong> पर देख सकते हैं। इसके अलावा आधिकारिक वेबसाइट 
      <strong><a href="https://jacresults.com" target="_blank">jacresults.com</a></strong> और 
      <strong><a href="https://jac.jharkhand.gov.in" target="_blank">jac.jharkhand.gov.in</a></strong> पर नतीजे देख और मार्कशीट डाऊनलोड कर सकते हैं।</p>
      `;
      statics.info =
        "Jharkhand बोर्ड 10वीं हाईस्कूल रिजल्‍ट 2025 (Jharkhand Board 10th High School Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
    if (stateKey == "rj") {
      statics.title =
        "Check Online Rajasthan Board 10th Result 2025, मैट्रिक रिजल्ट - NewsTak";
      statics.description =
        "Check Online Rajasthan Board 10th Result 2025 (Rajasthan बोर्ड मैट्रिक रिजल्ट). Get 10वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत की पूरी जानकारी यहाँ।";
      statics.keywords =
        "Rajathan Board 10th Result 2025, Rajathan Board Matric Result 2025, 10वीं रिजल्ट Rajathan बोर्ड";
      statics.canonical =
        "/education/board-results/rajasthan-board-10th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "Rajasthan बोर्ड 10th परीक्षा परिणाम",
        canonical_url: "/education/board-results/rajasthan-board-10th-result",
        amp_url: "",
      });
      statics.h1 = "Rajasthan बोर्ड 10th परीक्षा परिणाम";
      statics.stateText = "राजस्थान";
      statics.info =
        "Rajasthan बोर्ड 10वीं हाईस्कूल रिजल्‍ट 2025 (Rajasthan Board 10th High School Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
  }

  if (!tenthResult) {
    statics.imgSrc =
      "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/board_desktop_banner_12.png";
    statics.imgSrcMobile =
      "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/board_cat_banner_12.png";

    if (stateKey == "Bihar") {
      statics.title =
        "Check Online Bihar Board 12th Result 2025: बिहार बोर्ड इंटर रिजल्ट - NewsTak";
      statics.description =
        "Check Online Bihar Board 12th Result 2025 (बिहार बोर्ड इंटर रिजल्ट). Get BSEB 12वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत की पूरी जानकारी यहाँ।";
      statics.keywords =
        "Bihar Board 12th Result 2025, BSEB इंटर रिजल्ट, बिहार बोर्ड इंटर रिजल्ट, Bihar Board Inter Result 2025, BSEB Result 2025, 12वीं रिजल्ट बिहार बोर्ड";
      statics.canonical =
        "/education/board-results/bseb-bihar-board-12th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "बिहार बोर्ड 12th परीक्षा परिणाम 2025",
        canonical_url: "/education/board-results/bseb-bihar-board-12th-result",
        amp_url: "",
      });
      statics.h1 =
        "बिहार बोर्ड 12वीं परिणाम 2025 (Bihar Board 12th Result 2025)";
      statics.stateText = "बिहार";
      statics.info =
        "बिहार बोर्ड 12वीं रिजल्‍ट 2025 (Bihar Board 12th Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
    if (stateKey == "up") {
      statics.title =
        "Check Online UP Board 12th Result 2025: यूपी बोर्ड इंटर रिजल्ट - NewsTak";
      statics.description =
        "Check Online UP Board Class 12th Result 2025 (यूपी बोर्ड इंटर रिजल्ट): जानें उत्तर प्रदेश बोर्ड 12वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत से जुड़ी पूरी जानकारी यहाँ।";
      statics.keywords =
        "UP Board 12th Result 2025, UPMSP Inter Result, यूपी बोर्ड इंटर रिजल्ट, UP Board Result 2025, UP Board 12वीं रिजल्ट, UP 12th Marksheet, UP Board Topper List 2025, up board class 12th result";
      statics.canonical =
        "/education/board-results/uttar-pradesh-board-12th-result";
      statics.content = `<p>
      लाखों छात्र-छात्राओं को उत्तर प्रदेश माध्यमिक शिक्षा बोर्ड (UPMSP) की 12वीं के नतीजों का बेशब्री से इंतजार है.
      वे तुरंत और सटीक परिणाम जानना चाहते हैं. परिणाम घोषित होते ही तमाम वेबसाइट्स हैंग होने लगती हैं. हड़बड़ी में स्टूडेंट्स परेशान हो जाते हैं.
      नतीजे जानने में देरी हो जाती है. इन बातों के मद्देनजर <strong>newstak.in</strong> भरोसे वाला प्लेटफॉर्म है. यहां स्टूडेंट्स तुरंत और सटीक नतीजे जान सकेंगे।
    </p>
    <br />
    <p>
      <strong>UP बोर्ड 12वीं के नतीजे कब और कहां देखने को मिलेंगे?</strong><br />
      यूपी बोर्ड 12वीं की परीक्षाएं खत्म होने के बाद स्टूडेंट्स आगे का कॅरियर बनाने में जुट गए हैं.
      कोई इंजीनियरिंग करना चाहता है तो मेडिकल, कोई किसी जानी-मानी यूनिवर्सिटी में प्रवेश पाकर अपना कॅरियर संवारना चाहता है.
      इन सब बातों की नींव में है 12वीं का रिजल्ट. छात्र-छात्राएं रिजल्ट का बेशब्री से इंतजार कर रहे हैं.
      <strong>newstak.in</strong> अभी तक रिजल्ट से जुड़ी हर सटीक अपडेट देता रहा है. इससे जुड़ी अफवाहों का Fact check करके भी छात्र-छात्राओं को भ्रमित होने से बचाता रहा है.
      अब सटीक रिजल्ट भी यहीं मिलेगा. परिणाम घोषित होते ही News Tak पर <strong>UP Board 12th result 2025</strong> का एक टैब आ जाएगा.
      इस टैब को क्लिक करके स्टूडेंट्स रिजल्ट देख सकते हैं।
    </p>
    <br />
    <p>
      <strong>UP Board 12th Result 2025 : ऐसे देखें रिजल्ट</strong>
    </p>
    <ul className="list-disc list-inside">
      <li>सबसे पहले वेब ब्राउजर पर <strong><a target="_blank" href="https://upmsp.edu.in">upmsp.edu.in</a></strong> या <strong>newstak.in</strong> पर जाएं।</li>
      <li>'<strong>UP Board 10th Result 2025</strong>' वाला टैब मिलेगा. यहां क्लिक करें।</li>
      <li>12वीं परीक्षा के प्रवेश पत्र पर दिया गया रोल नंबर और मां का नाम दर्ज करें।</li>
      <li>‘View Result’ पर क्लिक करते ही परिणाम स्क्रीन पर दिखेगा।</li>
      <li>स्टूडेंट्स मार्कशीट डाउनलोड कर सकते हैं और इसका प्रिंट भी ले सकते हैं।</li>
    </ul>
    <br />
    <p>
      इसके साथ ही 12th के रिजल्ट से जुड़े कई सवालों के जवाब <strong>News Tak</strong> पर मिलेंगे।
    </p>`
      statics.breadCrumbs.push({
        id: "2",
        title: "यूपी बोर्ड 12th परीक्षा परिणाम 2025",
        canonical_url:
          "/education/board-results/uttar-pradesh-board-12th-result",
        amp_url: "",
      });
      statics.h1 =
        "यूपी बोर्ड 12th परीक्षा परिणाम 2025 (UP Board Class 12th Result 2025)";
      statics.stateText = "यूपी";
      statics.segment = "UP-12-board-result";
      statics.info =
        "UP बोर्ड 12वीं इंटर रिजल्‍ट 2025 (UP Board 12th Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
    if (stateKey == "mp") {
      statics.title =
        "Check Online MP Board 12th Result 2025: MPBSE एमपी बोर्ड इंटर रिजल्ट - NewsTak";
      statics.description =
        "Check Online MP Board Class 12th Result 2025 (एमपी बोर्ड इंटर रिजल्ट): जानें MPBSE Board 12वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत की पूरी जानकारी यहाँ।";
      statics.keywords =
        "MP Board 12th Result 2025, MPBSE Inter Result, एमपी बोर्ड 12वीं रिजल्ट, MP Board Result 2025, MPBSE 12th Marksheet, MP Board Topper List 2025";
      statics.canonical =
        "/education/board-results/madhya-pradesh-board-12th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "MP बोर्ड 12th परीक्षा परिणाम",
        canonical_url:
          "/education/board-results/madhya-pradesh-board-12th-result",
        amp_url: "",
      });
      statics.h1 =
        "एमपी बोर्ड 12th परीक्षा परिणाम 2025 (MP Board Class 12th Result 2025)";
      statics.stateText = "एमपी";
      statics.segment = "MP-12-board-result";
      statics.info =
        "MP बोर्ड 12वीं रिजल्‍ट 2025 (MP Board 12th Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
      statics.content = `लाखों छात्र-छात्राओं को मध्य प्रदेश माध्यमिक शिक्षा बोर्ड (MPBSE) की 12वीं के नतीजों का बेशब्री से इंतजार है. वे तुरंत और सटीक परिणाम जानना चाहते हैं. परिणाम घोषित होते ही तमाम वेबसाइट्स हैंग होने लगती हैं. हड़बड़ी में स्टूडेंट्स परेशान हो जाते हैं. नतीजे जानने में देरी हो जाती है. इन बातों के मद्देनजर newstak.in भरोसे वाला प्लेटफॉर्म है. यहां स्टूडेंट्स तुरंत और सटीक नतीजे जान सकेंगे।
      <br/><br/>
      <strong>MP बोर्ड 12वीं के नतीजे कब और कहां देखने को मिलेंगे?</strong><br/>
      MP बोर्ड 12वीं की परीक्षाएं खत्म होने के बाद स्टूडेंट्स आगे का कॅरियर बनाने में जुट गए हैं. कोई इंजीनियरिंग करना चाहता है तो मेडिकल, कोई किसी जानी-मानी यूनिवर्सिटी में प्रवेश पाकर अपना कॅरियर संवारना चाहता है. इन सब बातों की नींव में है 12वीं का रिजल्ट. छात्र-छात्राएं रिजल्ट का बेशब्री से इंतजार कर रहे हैं. newstak.in अभी तक रिजल्ट से जुड़ी हर सटीक अपडेट देता रहा है. इससे जुड़ी अफवाहों का Fact check करके भी छात्र-छात्राओं को भ्रमित होने से बचाता रहा है. अब सटीक रिजल्ट भी यहीं मिलेगा. परिणाम घोषित होते ही News Tak पर MP Board 12th result 2025 का एक टैब आ जाएगा.`
    }
    if (stateKey == "jh") {
      statics.title =
        "Check Online Jharkhand Board 12th Result 2025: झारखंड बोर्ड इंटर रिजल्ट - NewsTak";
      statics.description =
        "Check Online Jharkhand Board Calss 12th Result 2025 (झारखंड बोर्ड इंटर रिजल्ट): जानें JAC Board 12वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत से जुड़ी पूरी जानकारी यहाँ।";
      statics.keywords =
        "Jharkhand Board 12th Result 2025, JAC 12th Result, झारखंड बोर्ड 12वीं रिजल्ट, JAC Inter Result 2025, JAC Result 2025, Jharkhand Board Marksheet, JAC Topper List 2025, JAC 12th reult 2025";
      statics.canonical =
        "/education/board-results/jharkhand-board-12th-result";
      statics.breadCrumbs.push({
        id: "2",
        title: "Jharkhand बोर्ड 12th परीक्षा परिणाम",
        canonical_url: "/education/board-results/jharkhand-board-12th-result",
        amp_url: "",
      });
      statics.h1 =
        "झारखंड बोर्ड 12th परीक्षा परिणाम 2025 (Jharkhand Board Class 12th Result 2025)";
      statics.stateText = "झारखंड";
      statics.segment = "jharkhand-12-board-result";
      statics.content = ``;
      statics.info =
        "Jharkhand बोर्ड 12वीं इंटर रिजल्‍ट 2025 (Jharkhand Board Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
    if (stateKey == "rj") {
      statics.title =
        "Check Online Rajasthan Board 12th Result 2025, मैट्रिक रिजल्ट - NewsTak";
      statics.description =
        "Check Online Rajasthan Board 12th Result 2025 (Rajasthan बोर्ड मैट्रिक रिजल्ट). Get 10वीं रिजल्ट, मार्कशीट, टॉपर लिस्ट और पासिंग प्रतिशत की पूरी जानकारी यहाँ।";
      statics.keywords =
        "Rajathan Board 12th Result 2025, Rajathan Board Inter Result 2025, 12वीं रिजल्ट Rajathan बोर्ड";
      statics.canonical =
        "/education/board-results/rajasthan-board-12th-result";
      statics.breadCrumbs.push({
        id: "2",
        canonical_url: "/education/board-results/rajasthan-board-12th-result",
        amp_url: "",
      });
      statics.h1 = "Rajasthan बोर्ड 12th परीक्षा परिणाम";
      statics.stateText = "राजस्थान";
      statics.info =
        "Rajasthan बोर्ड 10वीं हाईस्कूल रिजल्‍ट 2025 (Rajasthan Board 12th High School Result 2025) यहां देखिए. नीचे अपना रोल नंबर और बाकी डिटेल डालकर नतीजे चेक कर सकेंगे";
    }
  }

  return statics;
}

export function createFaqSchema(stateKey = "up", tenthResult = true) {
  const faqObj = {
    schema: null,
  };
  if (tenthResult) {
    if (stateKey == "up") {
      faqObj.schema = [
        {
          "@type": "Question",
          name: "कब आएगा यूपी बोर्ड 10वीं की परीक्षा का रिजल्ट?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "यूपी बोर्ड 10वीं की परीक्षाएं इस बार 24 फरवरी 2025 से लेकर 12 मार्च 2025 तक बीच हुई थीं. माना जा रहा है कि नतीजे 25-30 अप्रैल के बीच जारी हो सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "newstak.in पर यूपी बोर्ड 10वीं का रिजल्ट कैसे चेक करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `स्टेप 1: न्यूज Tak की वेबसाइट newstak.in पर जाएं.
    स्टेप 2: होमपेज पर 'बोर्ड रिजल्ट' लिंक पर क्लिक करें.
    स्टेप 3: यहां यूपी बोर्ड 10वीं रिजल्ट' लिंक पर क्लिक करें.
    स्टेप 4: यहां अपना रोल नंबर डालें.
    स्टेप 5: यूपी 10वीं बोर्ड रिजल्ट की मार्कशीट स्क्रीन पर ओपन हो जाएगी.
    स्टेप 6: मार्कशीट डाउनलोड कर सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "10वीं बोर्ड का रिजल्ट पाने का और तरीका क्या है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `स्टेप 1: यूपी बोर्ड की आधिकारिक वेबसाइट http://results.upmsp.edu.in/ पर जाएं.

            स्टेप 2: होमपेज पर, 'UP Board Result' पर क्लिक करें.
            
            स्टेप 3: अब अपना रोल नंबर और कैप्चा कोड डालकर सबमिट करें.
            
            स्टेप 4: रिजल्ट आपकी स्क्रीन पर ओपन हो जाएगा.
            
            स्टेप 5: स्टूडेंट अपनी ऑनलाइन मार्कशीट डाउनलोड कर सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "बोर्ड परीक्षा में कौन पास, कौन फेल?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बोर्ड परीक्षा पास करने के लिए प्रत्येक विषय में कम से कम 33 फीसदी अंक पाना जरूरी है. यदि दो विषयों में 33 फीसदी से कम अंक आए तो स्टूडेंट कम्पार्टमेंट का आवेदन दे सकता है. दो से ज्यादा विषयों में 33 फीसदी से कम आने पर छात्र फेल माना जाएगा.",
          },
        },
        {
          "@type": "Question",
          name: "क्या छात्र मोबाइल में रिजल्ट देख सकते हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां, यूपी बोर्ड की वेबसाइट को अपने मोबाइल के ब्राउज़र में ओपन करके रिजल्ट चेक किया जा सकता है, बशर्ते कि इंटरनेट स्पीड अच्छी हो.",
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट देखने के लिए क्या चीजें जरूरी हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: " रिजल्ट देखने के लिए रोल नंबर जरूरी है. बेहतर होगा रिजल्ट के समय अपना एडमिट कार्ड साथ रखें.",
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट घोषित होने के बाद वेबसाइट स्लो हो तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "रिजल्ट घोषित होते ही यदि शिक्षा विभाग की वेबसाइट स्लो हो तो तुरंत newstak.in पर आकर परिणाम देख सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "अगर रोल नंबर भूल गए तो क्या करना होगा?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बेहतर होगा कि रिजल्ट जारी होने से पहले स्कूल से संपर्क करके अपना रोल नंबर प्राप्त कर लें.",
          },
        },
        {
          "@type": "Question",
          name: "क्या रिजल्ट के साथ मार्कशीट भी मिलेगी?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां. ऑनलाइन रिजल्ट के साथ डिजिटल मार्कशीट भी स्क्रीन पर डिस्प्ले होती है जिसे आप डाउनलोड कर सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "क्या 10th का रिजल्ट SMS के जरिए भी मिल सकता है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बोर्ड ऐसी सुविधा देता है तो आपके मोबाइल नंबर पर एसएमएस के जरिए रिजल्ट मिल जाएगा.",
          },
        },
        {
          "@type": "Question",
          name: "क्या रिजल्ट से जुड़ा एसएमएस अलर्ट मिलेगा?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "यदि बोर्ड इस बाबात पहले से मोबाइल नंबर रजिस्टर्ड करता है तो रिजल्ट जारी होते ही एसएमएस अलर्ट मिलेगा.",
          },
        },
      ];
    }
    if (stateKey == "jh") {
      faqObj.schema = [
        {
          "@type": "Question",
          name: "कब आएगा झारखंड बोर्ड 10वीं की परीक्षा का रिजल्ट?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "झारखंड बोर्ड 10वीं की परीक्षाएं इस बार 11 फरवरी 2025 से लेकर 4 मार्च 2025 तक बीच आयोजित हुई थी. नतीजे 20-30 अप्रैल के बीच जारी हो सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "newstak.in पर झारखंड बोर्ड 10वीं का रिजल्ट कैसे चेक करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `स्टेप 1: न्यूज Tak की वेबसाइट newstak.in पर जाएं.
    स्टेप 2: होमपेज पर 'बोर्ड रिजल्ट' लिंक पर क्लिक करें.
    स्टेप 3: यहां झारखंड बोर्ड 10वीं रिजल्ट' लिंक पर क्लिक करें.
    स्टेप 4: यहां अपना रोल नंबर डालें.
    स्टेप 5: झारखंड 10वीं बोर्ड रिजल्ट की मार्कशीट स्क्रीन पर ओपन हो जाएगी.
    स्टेप 6: यहां से मार्कशीट डाउनलोड कर प्रिंटआउट भी ले सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "10वीं बोर्ड का रिजल्ट और कैसे जानें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `स्टेप 1: झारखंड बोर्ड की आधिकारिक वेबसाइट http://jac.jharkhand.gov.in/ पर जाएं.

            स्टेप 2: होमपेज पर 'JAC 10th Result 2025' लिंक पर क्लिक करें
            
            स्टेप 3: अपना रोल नंबर और रोल कोड दर्ज कर Submit बटन पर क्लिक करें.
            
            स्टेप 4: रिजल्ट आपकी स्क्रीन पर ओपन हो जाएगा.
            
            स्टेप 5: स्टूडेंट अपनी ऑनलाइन मार्कशीट डाउनलोड कर सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "बोर्ड परीक्षा में कौन पास, कौन फेल?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बोर्ड परीक्षा में सफल होने के लिए छात्रों को हर विषय में कम से कम 33 प्रतिशत अंक प्राप्त करना जरूरी है. यदि किसी छात्र के दो विषयों में 33 प्रतिशत से कम अंक आते हैं, तो वह कम्पार्टमेंट परीक्षा के लिए आवेदन कर सकता है. हालांकि, अगर दो से ज्यादा विषयों में न्यूनतम अंक नहीं मिलते, तो उस छात्र को फेल माना जाएगा.",
          },
        },
        {
          "@type": "Question",
          name: "क्या छात्र मोबाइल में रिजल्ट देख सकते हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "जी हां, झारखंड बोर्ड की ऑफिशियल वेबसाइट को अपने मोबाइल के ब्राउज़र में खोलकर रिजल्ट चेक किया जा सकता है, लेकिन ध्यान देने वाली बात ये है कि आपके इंटरनेट की स्पीड धीमी न हो.",
          },
        },
        {
          "@type": "Question",
          name: "अगर रिजल्ट आने से पहले रोल नंबर भूल जाएं तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "इस स्थिति में सबसे पहले स्कूल से संपर्क करें और अपना रोल नंबर प्राप्त करें. रिजल्ट जारी होने से पहले ही ये काम कर लेना अच्छा होगा.",
          },
        },
        {
          "@type": "Question",
          name: "क्या 10वीं के रिजल्ट के साथ मार्कशीट भी ऑनलाइन मिलेगी?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां, ऑनलाइन रिजल्ट के साथ डिजिटल मार्कशीट भी स्क्रीन पर दिखाई देगी, जिसे आप डाउनलोड और प्रिंट कर भविष्य के लिए रख सकते है.",
          },
        },
        {
          "@type": "Question",
          name: "क्या 10वीं का रिजल्ट SMS से भी मिल सकता है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "अगर बोर्ड यह सुविधा प्रदान करता है, तो आपके रजिस्टर्ड मोबाइल नंबर पर SMS के जरिए भी रिजल्ट भेजा जा सकता है.",
          },
        },
        {
          "@type": "Question",
          name: "क्या रिजल्ट से जुड़ा SMS अलर्ट भी मिलेगा?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "अगर बोर्ड ने रिजल्ट से पहले मोबाइल नंबर रजिस्टर करने की सुविधा दी है, तो रिजल्ट जारी होते ही आपको SMS अलर्ट मिल जाएगा.",
          },
        },
      ];
    }
    if (stateKey == "mp") {
      faqObj.schema = [
        {
          "@type": "Question",
          name: "MP Board 10th Result 2025 कब जारी होगा?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "रिजल्ट मई 2025 में जारी होने की संभावना है.",
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट कैसे चेक करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `छात्र http://mpresults.nic.in/ पर जाकर अपना रोल नंबर और एप्लीकेशन नंबर डालकर रिजल्ट देख सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "आधिकारिक वेबसाइट के अलावा कहां रिजल्ट देख सकते हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `आधिकारिक वेबसाइट के अलावा newstak.in पर जाकर स्टूडेंट्स तुरंत रिजल्ट पा सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "MP Board 10वीं में पास होने के लिए कितने प्रतिशत चाहिए?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हर विषय में कम से कम 33% अंक जरूरी हैं.",
          },
        },
        {
          "@type": "Question",
          name: "अगर फेल हो गए तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "एक या दो विषयों में फेल होने पर कंपार्टमेंट परीक्षा दे सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "SMS से रिजल्ट पा सकते हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बोर्ड ऐसी सुविधा देता है तो आप मोबाइल नंबर पर एसएमएस के जरिए रिजल्ट पा सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट से जुड़े एसएमएस अलर्ट की सुविधा है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "एमपी बोर्ड ऐसी सुविधा देता है तो रिजल्ट घोषित होने से पहले मोबाइल रजिस्टर्ड कराकर एसएमएस अलर्ट की सुविधा ले सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "क्या रिजल्ट के साथ फुल मार्कशीट देख सकते हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "जी हां, आधिकारिक वेबसाइट पर फुल मार्कशीट देखने के साथ ही उसे डाउनलोड भी कर सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट देखने के लिए क्या-क्या चाहिए?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "रिजल्ट देखने के लिए अपना रोल नंबर, डेट ऑफ बर्थ और मोबाइल नंबर लेकर बैठें.",
          },
        },
        {
          "@type": "Question",
          name: "रोल नंबर खो जाए तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "रोल नंबर खोने पर स्टूडेंट्स को रिजल्ट जारी होने से पहले स्कूल से संपर्क करना चाहिए.",
          },
        },
      ];
    }
  }

  if (!tenthResult) {
    if (stateKey == "up") {
      faqObj.schema = [
        {
          "@type": "Question",
          name: "यूपी बोर्ड 12वीं रिजल्ट 2025 के नतीजें कब आएंगे?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "परीक्षाएं खत्म हो चुकी हैं. कॉपियों का मूल्यांकन भी आखिरी स्टेज में है. माना जा रहा है कि अप्रैल महीने के अखिरी सप्ताह तक रिजल्ट घोषित हो जाएगा.",
          },
        },
        {
          "@type": "Question",
          name: "12वीं का रिजल्ट देखने के लिए आधिकारिक वेबसाइट क्या है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `स्टूडेंट्स upresults.nic.in या upmsp.edu.in पर जाकर परिणाम चेक कर सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "इसके अलावा भी रिजल्ट देखने का सटीक विकल्प क्या है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `इसके अलावा आप newstak.in पर फटाफट रिजल्ट देख सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "इंटरमीडिएट रिजल्ट चेक करते समय किन चीजों की जरूरत पड़ेगी?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "इंटरमीडिएट रिजल्ट के लिए रोल नंबर, रजिस्ट्रेशन नंबर और जन्मतिथि की जरूरत पड़ सकती है.",
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट घोषित होने के बाद भी परिणाम नहीं देख पा रहे तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "आधिकारिक वेबसाइट और newstak.in  पर भी परिणाम नहीं देख पा रहे तो घबराएं नहीं. अचानक वेबसाइट पर लोड बढ़ जाने से ऐसा हो सकता है. थोड़ी देर वेट करें. फिर परिणाम देख पाएंगे.",
          },
        },
        {
          "@type": "Question",
          name: "बोर्ड परीक्षा में कौन पास, कौन माना जाएगा फेल?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बोर्ड परीक्षा पास करने के लिए सभी विषय में कम से कम 33 फीसदी अंक लाना जरूरी है. यदि दो विषयों में 33 फीसदी से कम अंक आए तो स्टूडेंट कम्पार्टमेंट दे सकता है. दो से ज्यादा विषयों में 33 फीसदी से कम आने पर छात्र को फेल घोषित कर दिया जाएगा.",
          },
        },
        {
          "@type": "Question",
          name: "क्या इंटर की डिजिटल मार्कशीट तुरंत मिलती है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां, आधिरकारिक वेबसाइट पर रिजल्ट के साथ डिजिटल मार्कशीट भी दिखेगी जिसे डाउनलोड करके सेव कर लें. प्रिंटआउट भी ले सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट मोबाइल पर देख सकते हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बिल्कुल देख सकते हैं. मोबइल की नेट स्पीड अच्छी हो या आप वाईफाई जोन में हों तो रिजल्ट तुरंत देख सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "अगर रोल नंबर खो जाए तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "कई बार बोर्ड रजिस्ट्रेशन नंबर या डेट ऑफ बर्थ से भी रिजल्ट देने की सुविधा दे सकता है. बेहतर होगा कि आप पहले की स्कूल से संपर्क कर रोल नंबर जान लें.",
          },
        },
        {
          "@type": "Question",
          name: "क्या रिजल्ट से जुड़े क्वेरी के लिए कोई हेल्पलाइन नंबर की सुविधा है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "यूपी बोर्ड की आधिकारिक वेबसाइट पर हेल्पलाइन नंबर है. इन नंबरों पर निर्धारित दिन समय में बात करके अपने सवालों के जवाब पा सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "क्या रिजल्ट से जुड़ा एसएमएस अलर्ट मिलेगा?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "यदि बोर्ड इस बाबात पहले से मोबाइल नंबर रजिस्टर्ड करता है तो रिजल्ट जारी होते ही एसएमएस अलर्ट मिलेगा.",
          },
        },
      ];
    }
    if (stateKey == "jh") {
      faqObj.schema = [
        {
          "@type": "Question",
          name: "कब आएगा झारखंड बोर्ड 12वीं की परीक्षा का परिणाम?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "झारखंड बोर्ड 12वीं की परीक्षाएं इस बार 11 फरवरी 2025 से लेकर 4 मार्च 2025 तक बीच आयोजित हुई थी. नतीजे 20-30 अप्रैल के बीच जारी हो सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "newstak.in पर झारखंड बोर्ड 12वीं का रिजल्ट कैसे चेक करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `स्टेप 1: न्यूज Tak की वेबसाइट newstak.in पर जाएं.
    स्टेप 2: होमपेज पर 'बोर्ड रिजल्ट' लिंक पर क्लिक करें.
    स्टेप 3: यहां झारखंड बोर्ड 12वीं रिजल्ट' लिंक पर क्लिक करें.
    स्टेप 4: यहां अपना रोल नंबर डालें.
    स्टेप 5: झारखंड 12वीं बोर्ड रिजल्ट की मार्कशीट स्क्रीन पर ओपन हो जाएगी.
    स्टेप 6: यहां से मार्कशीट डाउनलोड कर प्रिंटआउट भी ले सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "12वीं बोर्ड का रिजल्ट पाने के और क्या-क्या तरीके हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `स्टेप 1: झारखंड बोर्ड की आधिकारिक वेबसाइट http://jac.jharkhand.gov.in/ पर जाएं.

            स्टेप 2: होमपेज पर 'JAC 12th Result 2025' लिंक पर क्लिक करें
            
            स्टेप 3: अपना रोल नंबर और रोल कोड दर्ज कर Submit बटन पर क्लिक करें.
            
            स्टेप 4: रिजल्ट आपकी स्क्रीन पर ओपन हो जाएगा.
            
            स्टेप 5: स्टूडेंट अपनी ऑनलाइन मार्कशीट डाउनलोड कर सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "बोर्ड परीक्षा में कौन पास, कौन फेल?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "बोर्ड परीक्षा में सफल होने के लिए छात्रों को हर विषय में कम से कम 33 प्रतिशत अंक प्राप्त करना जरूरी है. यदि किसी छात्र के दो विषयों में 33 प्रतिशत से कम अंक आते हैं, तो वह कम्पार्टमेंट परीक्षा के लिए आवेदन कर सकता है. हालांकि, अगर दो से ज्यादा विषयों में न्यूनतम अंक नहीं मिलते, तो उस छात्र को फेल माना जाएगा.",
          },
        },
        {
          "@type": "Question",
          name: "क्या छात्र मोबाइल में रिजल्ट देख सकते हैं?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "जी हां, झारखंड बोर्ड की ऑफिशियल वेबसाइट को अपने मोबाइल के ब्राउज़र में खोलकर रिजल्ट चेक किया जा सकता है, लेकिन ध्यान देने वाली बात ये है कि आपके इंटरनेट की स्पीड धीमी न हो.",
          },
        },
        {
          "@type": "Question",
          name: "ऑनलाइन रिजल्ट देखने के लिए क्या-क्या डिटेल जरूरी है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "रिजल्ट देखने के लिए रोल नंबर सबसे जरूरी है. रिजल्ट देखने से पहले अपना एडमिट कार्ड अपने पास रखें ताकि सही जानकारी दर्ज कर सकें.",
          },
        },
        {
          "@type": "Question",
          name: "अगर ऑफिशियल वेबसाइट स्लो या डाउन हो तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "रिजल्ट जारी होने के बाद अगर बोर्ड की ऑफिशियल वेबसाइट स्लो हो जाए हो तो आप newstak.in पर आकर रियल टाइम परिणाम देख सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "अगर रिजल्ट आने से पहले एडमिट कार्ड खो गया तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "स्कूल से तुरंत संपर्क करें और अपना रोल नंबर प्राप्त करें. यह रिजल्ट जारी होने से पहले ही कर लेना बेहतर रहेगा.",
          },
        },
        {
          "@type": "Question",
          name: "क्या 12वीं के रिजल्ट के साथ मार्कशीट भी मिलेगी?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां, ऑनलाइन रिजल्ट के साथ डिजिटल मार्कशीट भी स्क्रीन पर दिखाई देगी, जिसे आप डाउनलोड और प्रिंट कर सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "क्या 12th का रिजल्ट SMS के जरिए भी मिल सकता है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "यदि बोर्ड यह सुविधा प्रदान करता है, तो आपके रजिस्टर्ड मोबाइल नंबर पर एसएमएस के जरिए भी रिजल्ट भेजा जा सकता है.",
          },
        },
        {
          "@type": "Question",
          name: "क्या रिजल्ट से जुड़ा एसएमएस अलर्ट मिलेगा?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "अगर बोर्ड ने रिजल्ट से पहले मोबाइल नंबर रजिस्टर करने की सुविधा दी है, तो रिजल्ट घोषित होते ही SMS अलर्ट मिल जाएगा.",
          },
        },
      ];
    }

    if (stateKey == "mp") {
      faqObj.schema = [
        {
          "@type": "Question",
          name: "एमपी बोर्ड 12वीं का रिजल्ट 2025 कब आएगा?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "एमपी बोर्ड 12वीं की परीक्षाएं मार्च में संपन्न हो चुकी हैं. उम्मीद है कि अप्रैल के आखिरी हफ्ते या मई के पहले सप्ताह तक रिजल्ट जारी कर दिया जाएगा.",
          },
        },
        {
          "@type": "Question",
          name: "12वीं का रिजल्ट देखने के लिए आधिकारिक वेबसाइट कौन सी है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `छात्र http://mpresults.nic.in/ पर जाकर अपना रोल नंबर और एप्लीकेशन नंबर डालकर रिजल्ट देख सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट देखने का कोई आसान और जल्दी विकल्प है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: `हां, आप सीधे newstak.in पर भी अपना रिजल्ट रोल नंबर डालकर तेज़ी से देख सकते हैं.`,
          },
        },
        {
          "@type": "Question",
          name: "रिजल्ट चेक करने के लिए किन दस्तावेजों की जरूरत होगी?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "रिजल्ट देखने के लिए छात्रों को रोल नंबर और एप्लीकेशन नंबर की जरूरत होगी. ये दोनों जानकारी एडमिट कार्ड में दी गई होती है.",
          },
        },
        {
          "@type": "Question",
          name: "यदि रिजल्ट साइट पर नहीं खुले तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "यदि ऑफिशियल साइट या newstak.in पर रिजल्ट लोड न हो तो घबराएं नहीं. ज्यादा ट्रैफिक के चलते ऐसा होता है. थोड़ी देर बाद फिर से कोशिश करें.",
          },
        },
        {
          "@type": "Question",
          name: "पास होने के लिए न्यूनतम कितने अंक चाहिए?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हर विषय में कम से कम 33% अंक जरूरी हैं. एक या दो विषयों में कम अंक आने पर छात्र कंपार्टमेंट परीक्षा दे सकता है.",
          },
        },
        {
          "@type": "Question",
          name: "क्या डिजिटल मार्कशीट तुरंत मिलेगी?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां, रिजल्ट के साथ ही ऑफिशियल वेबसाइट mpbse.nic.in पर डिजिटल मार्कशीट उपलब्ध होगी, जिसे डाउनलोड कर सेव किया जा सकता है.",
          },
        },
        {
          "@type": "Question",
          name: "मोबाइल से रिजल्ट देखा जा सकता है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां, मोबाइल से भी आसानी से रिजल्ट देखा जा सकता है. बस नेट कनेक्शन तेज़ होना चाहिए या वाई-फाई से जुड़ें.",
          },
        },
        {
          "@type": "Question",
          name: "रोल नंबर खो जाए तो क्या करें?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "अगर रोल नंबर नहीं मिल रहा तो अपने स्कूल से संपर्क करें या बोर्ड की साइट पर उपलब्ध विकल्पों से एप्लीकेशन नंबर और DOB के ज़रिए भी ट्राय कर सकते हैं.",
          },
        },
        {
          "@type": "Question",
          name: "क्या बोर्ड की ओर से कोई हेल्पलाइन नंबर होता है?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "हां, MPBSE की ऑफिशियल वेबसाइट mpbse.nic.in पर हेल्पलाइन नंबर दिए जाते हैं. छात्रों की मदद के लिए रिजल्ट सीजन में ये सक्रिय रहते हैं.",
          },
        },
      ];
    }
  }

  return faqObj;
}
